import React from 'react';
import axios from 'axios';
import { get } from 'lodash';
import {
  CSRF_TOKEN,
  requestCallback
} from '../../lib/helpers';

const AdjustPointInput = ({
  campaignId, userId,
  buttonTxt = 'OK'
}) => {
  const onSubmit = (e) => {
    e.preventDefault()
    const $els = e.target.elements
    const points = get($els, 'points.value', 0)

    if (confirm(`Are you sure to give ${points} points to User ID ${userId}?`)) {
      const formData = new FormData()
      formData.append('user_id', userId)
      formData.append('campaign_id', campaignId)
      formData.append('points', points)
      formData.append('authenticity_token', CSRF_TOKEN)

      const headers = {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }

      const endpoint = `/${gon.currentProvider}/api/point_histories`

      requestCallback(
        axios({
          method: 'POST',
          url: endpoint,
          data: formData,
          headers: headers
        })
      )
    }
  }

  return (
    <React.Fragment>
      <form
        className='UserCampaignList__form__flex'
        onSubmit={onSubmit}
      >
        <input
          type='number'
          className='Input Input__inline Input__small'
          name='points'
        />
        <button
          className='Button Button--small Button--blue'
        >{buttonTxt}</button>
      </form>
    </React.Fragment>
  );
}

export default AdjustPointInput
